import { initializeApp } from 'firebase/app';
import { getFirebaseConfig } from './config';

export const app = initializeApp(getFirebaseConfig());